import type { StackProps } from "@mui/material/Stack"
import Stack from "@mui/material/Stack"

type SectionBarProps = StackProps

export default function SectionBar(props: SectionBarProps) {
  return (
    <Stack
      direction={"row"}
      sx={{
        flex: 1,
        width: "100%",
        height: "3.5rem",
        maxHeight: "3.5rem",
        minHeight: "3.5rem",
        overflow: "hidden",
        px: 2,
        borderBottom: 1,
        borderColor: "divider",
        ...props?.sx
      }}
    >
      {props?.children}
    </Stack>
  )
}
